// Client-side CSV download utility
export function downloadCsv(filename, rows, headers) {
  const esc = (v) => {
    if (v == null) return "";
    const s = String(v).replaceAll('"', '""');
    return /[",\n;]/.test(s) ? `"${s}"` : s;
  };
  const lines = [];
  if (headers) lines.push(headers.map(esc).join(","));
  for (const r of rows) {
    const arr = headers ? headers.map((h) => r[h]) : Object.values(r);
    lines.push(arr.map(esc).join(","));
  }
  const bom = "\uFEFF"; // Excel Turkish support
  const blob = new Blob([bom + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function csvButtonBase() {
  return "bg-bg-base border border-bg-border text-text-primary hover:bg-bg-hover text-xs font-medium px-3 py-1.5 rounded-lg flex items-center gap-1.5";
}
